import { createFileRoute } from '@tanstack/react-router'

import { PageCard, PageLayout } from '@/components/ui/page'

import { AccountFormCreate } from '@/features/account/components/account-form'

export const Route = createFileRoute('/_app/settings/user/create')({
	component: Component,
})

function Component() {
	return (
		<PageLayout.Root>
			<PageLayout.Header
				breadcrumbs={[
					['/settings', 'Pengaturan'],
					['/settings/user', 'Pengguna'],
					['/settings/user/create', 'Tambah Pengguna'],
				]}
			/>
			<PageCard.Root>
				<PageCard.Header title="Tambah Pengguna" />
				<AccountFormCreate />
			</PageCard.Root>
		</PageLayout.Root>
	)
}
